import { IPoint } from 'framework/utils/math-utils';
import { IHexSpaceData, IHexGridData, IGameData } from 'js/bubbleCore/types';
import { Bubble } from 'js/bubbleCore/bubbles/types';
import { updatePositionInSpace } from 'js/bubbleCore/handlers/updatePositionInSpace';
import { testBubbleGridCollision } from 'js/bubbleCore/handlers/collisions/checkShootedGridCollisions';
import { BubbleFactory } from 'js/bubbleCore/bubbles/BubbleFactory';
import { prepareBubbleToShoot } from 'js/bubbleCore/handlers/shoot';
import { findAvailableSpace } from 'js/bubbleCore/bubbles/behavior/putBubbleToGrid';
import { IEvent, EventType, Wall } from 'js/bubbleCore/events';

export interface ITestShootResult {
  positions: IPoint[];
  hex?: IPoint;
}

let testBubble: Bubble | null = null;

const positionsLimit = 40;

export function testShoot(
  factory: BubbleFactory,
  data: IGameData,
  targetPoint: IPoint,
): ITestShootResult {

  const result: ITestShootResult = {
    positions: [],
  };

  if (testBubble === null) testBubble = factory.createRegular(0, 0);

  prepareBubbleToShoot(data, testBubble, targetPoint);

  let colliders: Bubble[] | null = null;
  let limit = positionsLimit;

  while (colliders === null && limit > 0) {
    limit--;
    const events: IEvent[] = [];
    updatePositionInSpace(testBubble, data.shootingSpace, events);

    colliders = testBubbleGridCollision(testBubble, data.grid);
    if (!colliders) {
      result.positions.push({x: testBubble.hexSpaceX, y: testBubble.hexSpaceY});
    }

    const hasTopCollision = events.some((event) => {
      return (
        event.type === EventType.BubbleSpaceLimitCollision &&
        (event as IEvent<EventType.BubbleSpaceLimitCollision>).data.wall === Wall.Top
      )
    });

    if (hasTopCollision) break;
  }

  if (colliders) {
    const freeSpace = findAvailableSpace(data.grid, testBubble, colliders);

    if (freeSpace) {
      result.hex = {
        x: freeSpace.offsetPosition.x,
        y: freeSpace.offsetPosition.y,
      };
    }
  }

  return result;
}